import React from 'react';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing TooltipHost from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Tooltip from '@fluentui/react-components' instead. */
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import loc from 'owa-localize';
import {
    safeModeLabel,
    recoveryModeLabel,
    configJsonActiveLabel,
    configJsonActiveDetails,
} from './getExtraTopRibbonControlsAfterTabs.locstring.json';
import { modeContainer, configJsonIndicator } from './getExtraTopRibbonControlsAfterTabs.scss';

export const SafeMode: React.FC = () => (
    <div className={modeContainer}>
        <label>{loc(safeModeLabel)}</label>
    </div>
);

export const RecoveryMode: React.FC = () => (
    <div className={modeContainer}>
        <label>{loc(recoveryModeLabel)}</label>
    </div>
);

export const ConfigJsonActive: React.FC = () => (
    <div className={modeContainer}>
        <TooltipHost content={loc(configJsonActiveDetails)}>
            <span className={configJsonIndicator}>{loc(configJsonActiveLabel)}</span>
        </TooltipHost>
    </div>
);
